<ul class="dashboard-menu">
    <li [routerLinkActive]="['active']">
        <a routerLink="/dashboard/dashboard-statistics">
            <i class="fa fa-tachometer"></i> Dashboard
        </a>
    </li>
    <hr>
    <li [routerLinkActive]="['active']"><a routerLink="/dashboard/profile-guide"><i class="fa fa-question"></i>Profile
    Guide</a></li>
    <hr>
    <li [routerLinkActive]="['active']"><a routerLink="/dashboard/profile"><i class="fa fa-file"></i>My Profile</a></li>
    <hr>
    <li [routerLinkActive]="['active']"><a routerLink="/dashboard/personal-info"><i class="fa fa-plus"></i>Create Personal
    Info</a></li>
    <hr>
    <li routerLinkActive="active"><a routerLink="/dashboard/work-experience"><i class="fa fa-plus"></i>Add work Experience</a>
    </li>
    <hr>
    <li routerLinkActive="active"><a routerLink="/dashboard/educational-info"><i class="fa fa-plus"></i>Add educational
    info</a></li>
    <hr>
    <li [routerLinkActive]="['active']"><a routerLink="/dashboard/referee"><i class="fa fa-plus"></i>Add referees</a></li>
    <hr>
    <li [routerLinkActive]="['active']"><a routerLink="/dashboard/cvs"><i class="fa fa-plus"></i>Upload / update CV</a></li>
    <hr>
    <li [routerLinkActive]="['active']"><a routerLink="/dashboard/uploads"><i class="fa fa-plus"></i>Upload certificates</a></li>
    <hr>
    <li routerLinkActive="active">
        <a routerLink="/dashboard/manage-applications">
            <i class="fa fa-briefcase"></i> manage jobs
        </a>
    </li>
    <hr>
    <li><a routerLink="/update-password"><i class="fa fa-lock"></i>change password</a></li>

</ul>